import { toast } from "sonner";
import { Rocket, X } from "lucide-react";
import { isMicrotxPreviewOn, setMicrotxPreview, MICROTX_BUILD_ON } from "@/config";

// Tiny amber badge shown only when the per-browser monetization preview override is active
// (and the global build flag is off). Reassures a dogfooding admin that they're seeing the
// demo monetization UI, not the real live experience. Click to turn it off + reload.
export function PreviewModeBadge() {
  if (MICROTX_BUILD_ON || !isMicrotxPreviewOn()) return null;
  const disable = () => {
    setMicrotxPreview(false);
    toast.success("Monetization preview off — reloading…");
    setTimeout(() => window.location.reload(), 600);
  };
  return (
    <button
      onClick={disable}
      title="Monetization preview is on (this device only). Click to turn off."
      className="group fixed right-3 top-3 z-50 flex items-center gap-1.5 rounded-full border border-amber-400/40 bg-amber-400/15 px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider text-amber-300 shadow-lg backdrop-blur-md transition-colors hover:bg-amber-400/25"
      data-testid="preview-mode-badge"
    >
      <Rocket className="h-3.5 w-3.5" />
      Preview mode
      <X className="h-3 w-3 opacity-60 transition-opacity group-hover:opacity-100" />
    </button>
  );
}
